import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  constructor(
    private router: Router,
    private afs: AngularFirestore,
    public afAuth: AngularFireAuth
  ) {
    // afAuth.authState.subscribe(val => {
    //   if (val) {
    //     router.navigate(['/dashboard']);
    //   }
    // });
  }

  login() {
    this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(creds => {
      this.afs.collection('users').doc(creds.user.uid).set({
        name: creds.user.displayName,
        email: creds.user.email,
        image: creds.user.photoURL
      }, { merge: true });
      this.router.navigate(['/dashboard']);
    }).catch(error => {
      // error.code will match one of the following:
      // error.message has a user-facing description
      // auth/account-exists-with-different-credential
      // auth/auth-domain-config-required
      // auth/cancelled-popup-request
      // auth/operation-not-allowed
      // auth/operation-not-supported-in-this-environment
      // auth/popup-blocked
      // auth/popup-closed-by-user
      // auth/unauthorized-domain
    });
  }
}




// WEBPACK FOOTER //
// /Users/traev/Sites/btt/src/app/public/home/home.component.ts